import { updateSelectedBookReturnJourneyDateAction } from "../../../Actions/LogicActions/BookReturnJourney/UpdateSelectedBookReturnJourneyDateAction";
import { updateSelectedRangeAction } from "../../../Actions/LogicActions/BookReturnJourney/UpdateSelectedRangeAction";
import { backToBookingClickAction } from "../../../Actions/UIActions/BookReturnJourney/BackToBookingClickAction";
import { bookReturnJourneyContinueClickAction } from "../../../Actions/UIActions/BookReturnJourney/BookReturnJourneyContinueClickAction";
import { bookReturnJourneyRedirectClickAction } from "../../../Actions/UIActions/BookReturnJourney/BookReturnJourneyRedirectClickAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { bookingTree, bookReturnJourneyTree } from "../../../Orchestrator/ConstantTree";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IBookingResponse } from "../../../Orchestrator/Types/Interface/IBooking";
import dayjs, { Dayjs } from "dayjs";
import { BookReturnJourneyContext } from "../Context/BookReturnJourneyContext";
import { bookReturnJourneyDateChangeAction } from "../../../Actions/UIActions/BookReturnJourney/BookReturnJourneyDateChangeAction";
import { passengerOutboundCheckReturnJourneyAction } from "../../../Actions/UIActions/BookReturnJourney/PassengerOutboundCheckReturnJourneyAction";

export class BookReturnJourneyInitStep extends StepFlow {
    get stepName() { return "BookReturnJourneyInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookReturnJourneyTree.BookReturnJourney.BookReturnJourneyRedirectClick,
                handler: async (data: any) => {
                    let context = this.getCtx<BookReturnJourneyContext>("bookReturnJourneyContext")!;
                    bookReturnJourneyRedirectClickAction.setParams(data.data!);
                    await bookReturnJourneyRedirectClickAction.execute();
                    if (bookReturnJourneyRedirectClickAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.allFulFillOutBoundPassIds = bookReturnJourneyRedirectClickAction.result?.allFulFillOutBoundPassIds ?? [];
                        context.outBoundPassengerPriceList = bookReturnJourneyRedirectClickAction.result?.outBoundPassengerPriceList ?? [];
                        context.bookingResponse = bookReturnJourneyRedirectClickAction.result?.bookingResponse ?? null;
                        // Stash the ORIGINAL booking code so #9 (book_roundtrip_payment_confirmation)
                        // can reference it after settlement, by which point bookingResponseAtom holds
                        // the new combined booking instead. Captured here at flow entry where the
                        // source booking is still in hand.
                        const originalCode = context.bookingResponse?.booking?.bookingCode;
                        if (originalCode) {
                            try {
                                localStorage.setItem("bookReturnOriginalBookingCode", String(originalCode));
                            } catch { }
                        }
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: data.data.route,
                        })
                    }
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookReturnJourneyTree.BookReturnJourney.BackToBookingClick,
                handler: async (data: any) => {
                    backToBookingClickAction.setParams(data.data!);
                    await backToBookingClickAction.execute();
                    // Also emit route change for immediate navigation
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: "/bookings",
                    });
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookReturnJourneyTree.BookReturnJourney.UpdateSelectedRange,
                handler: async (data: any) => {
                    updateSelectedRangeAction.setParams(data.data!);
                    await updateSelectedRangeAction.execute();
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookReturnJourneyTree.BookReturnJourney.UpdateSelectedBookReturnJourneyDate,
                handler: async (data: any) => {
                    updateSelectedBookReturnJourneyDateAction.setParams(data.data!);
                    await updateSelectedBookReturnJourneyDateAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookReturnJourneyTree.BookReturnJourney.BookReturnJourneyContinueClick,
                handler: async (data: any) => {
                    bookReturnJourneyContinueClickAction.setParams(data.data!);
                    await bookReturnJourneyContinueClickAction.execute();
                    if (isActionRunSuccessfully(bookReturnJourneyContinueClickAction)) {
                        const result: IDefaultActionResult = bookReturnJourneyContinueClickAction.result!;
                        if (result.status == "success") {
                            this.next();
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: data.data.redirectPath,
                            })

                        }
                    }
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookReturnJourneyTree.BookReturnJourney.PassengerOutboundCheck,
                handler: async (data: any) => {
                    passengerOutboundCheckReturnJourneyAction.setParams(data.data!);
                    await passengerOutboundCheckReturnJourneyAction.execute();
                }
            })
        );

        /**
        * This event used to close flow
        */
        _eventBus.on<void, void>({
            eventName: bookingTree.BookReturnJourney.Flow.Close,
            handler: async () => {
                const context = this.getCtx<BookReturnJourneyContext>("bookReturnJourneyContext")!
                if (context) {
                    context.nextTo = ["RetrieveBooking"];
                    this.next()
                }
            }
        })
    }

    async onExecute(): Promise<void> {
        this.setCtx("bookReturnJourneyContext", BookReturnJourneyContext);
        console.log("Book Return Journey Initialize.....")
    }

}

export const BookReturnJourneyInitStepDeclaration = new StepDefinition({
    stepName: "BookReturnJourneyInit_Step",
    stepClass: BookReturnJourneyInitStep
});